<template>
  <v-layout row wrap>
    <v-flex lg6 md10 offset-lg3 offset-md1 class="mt-5">
      <v-stepper v-model="e1" flat>
        <v-stepper-header style="display: none">
          <template v-for="question in allQuestions">
            <v-stepper-step :complete="e1>question.id" :key="question.id" :step="question.id"></v-stepper-step>
            <v-divider :key="`${question.id}-divider`"></v-divider>
          </template>
        </v-stepper-header>

        <v-stepper-items flat>
          <v-stepper-content
            v-for="(question, idx) in allQuestions"
            :key="`${question.id}-content`"
            :step="question.id"
          >
            <v-layout>
              <v-flex xs12>
                <v-card style="border-radius: 15px" class="mb-5" color="primary" height="auto" dark>
                  <v-card-title primary-title>
                    <h2 class="white--text" justify-center>{{question.question}}</h2>
                    <br />
                  </v-card-title>
                  <v-card-text v-if="question.input==false && !is_last_question">
                    <v-radio-group
                      :key="`${question.id}-options`"
                      v-model="newChamps[question.helper]"
                      column
                    >
                      <v-radio
                        v-for="(option,idxx) in question.options"
                        :key="'afd'+idxx"
                        :label="option.option"
                        color="#00FF00"
                        :value="option.id"
                      ></v-radio>
                    </v-radio-group>
                  </v-card-text>
                  <v-card-text v-if="question.input==true && !is_last_question">
                    <v-flex xs12>
                      <v-text-field
                        v-if="question.is_numeric"
                        single-line
                        :placeholder="question.hint"
                        append-outer-icon="edit"
                        v-model="newChamps[question.helper]"
                        outline
                        color="#00FF00"
                        type="tel"
                        mask="##"
                      ></v-text-field>
                      <v-text-field
                        v-else
                        single-line
                        :placeholder="question.hint"
                        append-outer-icon="edit"
                        v-model="newChamps[question.helper]"
                        outline
                        color="#00FF00"
                      ></v-text-field>
                    </v-flex>
                  </v-card-text>
                  <v-card-text v-if="is_last_question">
                    <v-layout row wrap>
                      <v-flex xs12 md9 sm8>
                        <v-layout row>
                          <Uploader64
                            txt="Galeria"
                            icon="far fa-image"
                            @getSelectedFile="championship.logoAux = $event"
                          />
                          <v-btn
                            v-if="avatarURL"
                            @click="clearAvatar"
                            icon
                            round
                            large
                            color="white"
                            class="primary--text"
                          >
                            <v-icon>delete</v-icon>
                          </v-btn>
                        </v-layout>

                        <!-- <v-btn round large color="white" class="primary--text">
                          <v-icon left>fa-palette</v-icon>Insreir só Cores
                        </v-btn>-->
                        <v-btn v-if="false" round large color="white" class="primary--text">
                          <v-icon left>web</v-icon>Pesquisar na Web
                        </v-btn>
                        <v-btn v-if="false" dark large color="lightgray">
                          Pular Etapa
                          <v-icon dark left>play_arrow</v-icon>
                        </v-btn>
                      </v-flex>
                      <v-flex xs12 md3 sm4>
                        <v-avatar :size="avatarSize" color="grey lighten-4">
                          <v-icon
                            :size="avatarSize*56/100"
                            color="grey lighten-1"
                            v-if="!avatarURL"
                          >fa-trophy</v-icon>
                          <v-img
                            v-if="avatarURL"
                            :src="avatarURL"
                            alt="avatar"
                            aspect-ratio="1"
                            class="grey lighten-5"
                            style="border-radius: 12px"
                            contain
                          />
                        </v-avatar>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-btn round color="#00FF00" @click="e1=question.id-1" v-if="e1>1">
                <v-icon dark>arrow_back_ios</v-icon>
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                round
                color="primary"
                @click="e1=question.id+1"
                :disabled="(!newChamps[question.helper])?  true: false"
              >
                <v-icon dark>{{is_last_question? 'fa-check-circle' : 'arrow_forward_ios'}}</v-icon>
              </v-btn>
            </v-layout>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-flex>

    <card-loading v-if="saving" :loadText="'Salvando'"></card-loading>
    <snack-comp :snackText="'textooo'" :snackTime="2000" v-if="snack" :snackP="true"></snack-comp>
  </v-layout>
</template>

<script>
import { mapActions } from "vuex";
import { mapState } from "vuex";
// import UploaderAvatar from "../imports/_uploader_image";
import { log } from "util";

export default {
  components: {
    // UploaderAvatar,
    Uploader64: () => import("@/components/imports/_uploader_b64.vue")
  },
  data() {
    return {
      ex8: null,
      e1: 1,
      lastStep: null,
      menu: false,
      menu2: false,
      saving: false,
      snack: false,
      newChamps: {
        logo: null
      },
      championship: {
        name: null,
        editions_attributes: [
          {
            number: 1,
            edition_modality_attributes: {
              id: null,
              number_teams: null,
              match_duration: null,
              group_configuration_attributes: {
                number_groups: null,
                teams_per_group: null
              }
            }
          }
        ],
        logoAux: null
      },
      defaultAvatar: "https://cdn.vuetifyjs.com/images/john.jpg",
      avatarSize: "160"
    };
  },
  methods: {
    clearAvatar() {
      this.championship.logo = null;
      this.championship.logoAux = null;
    },
    checkName() {
      //se existir, e1=1
    },
    nextStep: function(n) {
      /*if(n == this.atividades.queries.length){
        this.$router.push({name: 'Reports'})
      } else {
        this.e1=n+1;
      }*/
      this.e1 = n + 1;
    },
    genNewChampionship() {
      const {
        name,
        modality_id,
        number_teams,
        number_groups,
        teams_per_group,
        logo
      } = this.newChamps;

      this.championship = {
        name,
        user_id: this.user.id,
        logo,
        editions_attributes: [
          {
            number: 1,
            edition_modality_attributes: {
              number_teams,
              format: 1,
              // match_duration,
              group_configuration_attributes: {
                number_groups,
                teams_per_group
              }
            }
          }
        ]
      };
    },
    ...mapActions({
      getChamps: "Championship/index",
      create: "Championship/create"
    })
  },
  computed: {
    avatarURL() {
      if (this.championship.logoAux) {
        this.newChamps.logo = {
          data: this.championship.logoAux,
          filename: "logo" + this.newChamps.name + ".png",
          content_type: "image/png"
        };
        // this.newChamps["logo"] = this.championship.logo;
        // return URL.createObjectURL(this.championship.logo); // for formdata
        return this.championship.logoAux;
      } else {
        // return this.defaultAvatar
      }
    },
    is_last_question() {
      if (this.e1) {
        return this.e1 == this.allQuestions.length ? true : false;
      }
    },
    ...mapState({
      oneQuestion: state => state.Questions.oneQuestion,
      allQuestions: state => state.Questions.allQuestions,
      user: state => state.Users.user,
      createWasGood: state => state.Championship.createWasGood,
      createMessage: state => state.Championship.createMessage,
      createdID: state => state.Championship.createdID
    })
  },
  created() {
    // this.getChamps()
  },
  watch: {
    e1(nv, ov) {
      if (nv == 1) {
      } else if (nv == 2) {
        //this.checkName()
      } else if (nv == 3) {
      } else if (nv == 4) {
        // if(this.oneQuestion.options.id == 2){
        //   this.e1 = 7
        // }
      } else if (nv == 5) {
        if (this.newChamps.number_groups == 0) {
          this.e1++;
        }
      } else if (nv == 6) {
      } else if (nv == 7) {
        this.saving = true;
        this.genNewChampionship();
        this.create({ newChamps: this.championship }).then(() => {
          setTimeout(() => {
            this.saving = false;
            this.$router.push(`/campeonatos/${this.createdID}/equipes`);
          }, 500);
        });
      }
    },
    createWasGood(nv, ov) {
      // if (nv) {
      //   console.log("mudou valor");
      //   setTimeout(() => {
      //     this.saving = false;
      //     this.$router.push({
      //       name: "OCampeonato",
      //       params: { id: this.createdID }
      //     });
      //   }, 1000);
      // } else if (nv == false) {
      //   this.snack = true;
      //   this.saving = false;
      // }
    },
    newChamps(nv, ov) {
      // console.log({ nv });
    },
    date2start() {
      // this.newChamp.dateStart = this.date2start
    },
    date2finish() {
      // this.newChamp.dateFinish = this.date2finish
    }
  }
};
</script>